import { createQueryKeys } from '@lukemorales/query-key-factory'
import { useMutation } from '@tanstack/react-query'
import type { MutationHook } from '@/lib/react-query'
import type {
  StartRunnerTimesnapParams,
  UpdateRunnerParams,
} from '../model/params'
import { startRunnerTimesnap, updateRunner } from './requests'
import { useSetAtom } from 'jotai'
import { runnerAtom } from '../../../store/runner.store'
import type { Runner } from '~shared/types'

export const runnerQueryKeys = createQueryKeys('RUNNER', {})
export const RUNNER_MUTATION_KEYS_PREFIX = 'RUNNER'
export const runnerMutationKeys = {}

export const useStartRunnerTimesnap = ({
  options,
}: MutationHook<Runner, StartRunnerTimesnapParams> = {}) => {
  const setRunner = useSetAtom(runnerAtom)

  return useMutation({
    ...options,
    async mutationFn(params) {
      const { data } = await startRunnerTimesnap(params)

      return data
    },
    onSuccess(runner) {
      setRunner(runner)
    },
  })
}

export const useUpdateRunner = ({
  options,
}: MutationHook<Runner, UpdateRunnerParams> = {}) => {
  const setRunner = useSetAtom(runnerAtom)

  return useMutation({
    ...options,
    async mutationFn(params) {
      const { data } = await updateRunner(params)

      return data
    },
    onSuccess(runner) {
      setRunner(runner)
    },
  })
}
